import React from 'react'

const PadlockIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <defs>
      <clipPath id="padlockIcon">
        <path fill="#fff" d="M0 0h24v24H0z"/>
      </clipPath>
    </defs>
    <g>
      <g clipPath="url(#padlockIcon)">
        <path fill="var(--padlock, var(--icon, #969799))" d="M20.112 9.233h-1.45V7.298a6.765 6.765 0 00-13.529 0v1.935h-1.45a.483.483 0 00-.483.481v12.08a1.935 1.935 0 001.933 1.933h13.529a1.935 1.935 0 001.938-1.933V9.714a.483.483 0 00-.488-.481zm-6.768 10.091a.483.483 0 01-.48.537h-1.933a.483.483 0 01-.48-.537l.3-2.741a1.912 1.912 0 01-.791-1.554 1.933 1.933 0 113.866 0 1.912 1.912 0 01-.791 1.554zm2.419-10.091H8.032V7.298a3.866 3.866 0 117.731 0z"/>
      </g>
    </g>
  </svg>
);

export default PadlockIcon;
